/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioConstraintsResource
 */
export interface PortfolioConstraintsResource {
    /**
     * Maximum allowed size in bytes for images uploaded in portfolio content
     * @type {number}
     * @memberof PortfolioConstraintsResource
     */
    maxImageSizeBytes: number;
    /**
     * List of hostnames (without www. prefix) that are not allowed as links in portfolio content
     * @type {Array<string>}
     * @memberof PortfolioConstraintsResource
     */
    blockedLinkHosts: Array<string>;
}

/**
 * Check if a given object implements the PortfolioConstraintsResource interface.
 */
export function instanceOfPortfolioConstraintsResource(value: object): value is PortfolioConstraintsResource {
    if (!('maxImageSizeBytes' in value) || value['maxImageSizeBytes'] === undefined) return false;
    if (!('blockedLinkHosts' in value) || value['blockedLinkHosts'] === undefined) return false;
    return true;
}

export function PortfolioConstraintsResourceFromJSON(json: any): PortfolioConstraintsResource {
    return PortfolioConstraintsResourceFromJSONTyped(json, false);
}

export function PortfolioConstraintsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioConstraintsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'maxImageSizeBytes': json['maxImageSizeBytes'],
        'blockedLinkHosts': json['blockedLinkHosts'],
    };
}

export function PortfolioConstraintsResourceToJSON(value?: PortfolioConstraintsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxImageSizeBytes': value['maxImageSizeBytes'],
        'blockedLinkHosts': value['blockedLinkHosts'],
    };
}

